import { Module } from '../Module';

Module.instance().directive('tbModeSwitcher', <any[]>[
  '$location',
  ($location: ng.ILocationService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modeSwitcher.html',
      scope: {
        displayMode: '='
      }
    };
  }
]);
